export default __webpack_public_path__ + "static/media/Elec8.c91abd90.png";